/* CraftConsole Pro – Landingpage. Erzeugt von _build_shopify.py – nicht direkt bearbeiten. */
(function () {
    var root = document.querySelector('main.cc');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;
    if (hasIO) root.classList.add('cc-js');

    // ---------- Scroll-Animationen: Elemente erscheinen beim Hineinscrollen ----------
    var revealEls = root.querySelectorAll('.reveal, .reveal-zoom');
    if (hasIO) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealEls.forEach(function (el) { io.observe(el); });
      // Fallback: was beim Laden schon im Bild ist, sofort zeigen
      var showVisible = function () {
        revealEls.forEach(function (el) {
          if (!el.classList.contains('in') && el.getBoundingClientRect().top < window.innerHeight) el.classList.add('in');
        });
      };
      requestAnimationFrame(showVisible);
      window.addEventListener('load', showVisible);
    }

    // ---------- Zahlen hochzählen (15, 790) ----------
    function countUp(el) {
      var to = parseInt(el.getAttribute('data-to'), 10);
      if (reduce || !to) { el.textContent = to; return; }
      var start = null, dur = 1200;
      function step(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (hasIO) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); }
        });
      }, { threshold: 0.6 });
      root.querySelectorAll('.count').forEach(function (el) { el.textContent = '0'; cio.observe(el); });
    }

    // ---------- Kapitel-Navigation: aktives Kapitel + gleitende Markierung + Fortschritt ----------
    var nav = root.querySelector('.cc-nav');
    var links = nav ? Array.prototype.slice.call(nav.querySelectorAll('.cc-nav-links a')) : [];
    var linkBox = nav && nav.querySelector('.cc-nav-links');
    var pill = nav && nav.querySelector('.cc-nav-pill');
    var bar = nav && nav.querySelector('.cc-progress');
    var sections = links.map(function (a) { return root.querySelector(a.getAttribute('href')); });
    var current = null;

    function setActive(i) {
      if (current === i) return;
      current = i;
      links.forEach(function (a, j) { a.classList.toggle('is-active', j === i); });
      if (i < 0 || !pill) { if (pill) pill.style.opacity = '0'; return; }
      var a = links[i];
      pill.style.opacity = '1';
      pill.style.width = a.offsetWidth + 'px';
      pill.style.transform = 'translateX(' + a.offsetLeft + 'px)';
      // aktives Kapitel in der (mobil scrollbaren) Leiste sichtbar halten
      var target = a.offsetLeft - (linkBox.clientWidth - a.offsetWidth) / 2;
      linkBox.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
    }

    // Shopify: Kapitel-Leiste unter einen mitlaufenden Shop-Header setzen (Dawn/Ride: .shopify-section-header-sticky)
    var shopHeader = document.querySelector('.shopify-section-header-sticky');
    function updateTop() {
      if (!shopHeader) return;
      var off = Math.max(0, Math.round(shopHeader.getBoundingClientRect().bottom));
      root.style.setProperty('--cc-top', off + 'px');
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        updateTop();
        var navH = nav ? nav.getBoundingClientRect().bottom : 0;
        var probe = navH + window.innerHeight * 0.25;
        var idx = -1;
        sections.forEach(function (s, i) { if (s && s.getBoundingClientRect().top <= probe) idx = i; });
        setActive(idx);
        if (bar) {
          var r = root.getBoundingClientRect();
          var total = r.height - window.innerHeight;
          var p = total > 0 ? Math.min(Math.max(-r.top / total, 0), 1) : 0;
          bar.style.transform = 'scaleX(' + p + ')';
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { var c = current; current = null; setActive(c); onScroll(); });
    onScroll();

    // ---------- Aufklappbare Bedienelemente: immer nur eins offen, Scrollposition bleibt stabil ----------
    function accSet(item, open) {
      item.classList.toggle('is-open', open);
      var head = item.querySelector('.acc-head');
      if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
      var body = item.querySelector('.acc-body');
      if (body) body.hidden = !open;
    }
    function accToggle(item, forceOpen) {
      var head = item.querySelector('.acc-head');
      var before = head.getBoundingClientRect().top;
      var open = forceOpen === true ? true : !item.classList.contains('is-open');
      item.parentNode.querySelectorAll('.acc-item.is-open').forEach(function (o) { if (o !== item) accSet(o, false); });
      accSet(item, open);
      // angeklickte Kopfzeile bleibt an derselben Stelle im Bild, auch wenn oben etwas zugeklappt ist
      var after = head.getBoundingClientRect().top;
      if (Math.abs(after - before) > 1) window.scrollBy({ top: after - before, left: 0, behavior: 'instant' });
    }
    root.querySelectorAll('[data-acc] .acc-item').forEach(function (item) {
      var head = item.querySelector('.acc-head');
      head.addEventListener('click', function () { accToggle(item); });
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); accToggle(item); }
      });
    });
    // Links auf ein Element (#el-…) öffnen es und scrollen hin
    function openFromHash(hash, smooth) {
      if (!hash || hash.indexOf('#el-') !== 0) return false;
      var item = root.querySelector(hash);
      if (!item || !item.classList.contains('acc-item')) return false;
      item.parentNode.querySelectorAll('.acc-item.is-open').forEach(function (o) { if (o !== item) accSet(o, false); });
      accSet(item, true);
      item.scrollIntoView({ behavior: smooth && !reduce ? 'smooth' : 'auto', block: 'start' });
      return true;
    }
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#el-"]');
      if (a && openFromHash(a.getAttribute('href'), true)) e.preventDefault();
    });
    if (location.hash) openFromHash(location.hash, false);

    // ---------- Vollbild-Ansicht (Lightbox): Klick auf ein Bild, in Galerien durchblättern ----------
    // Später echte Bilder: <img src="…" alt="…" data-full="URL in hoher Auflösung"> – data-full ist optional.
    var lbItems = Array.prototype.filter.call(root.querySelectorAll('.ph, img.cc-shot, img.media, .ph-gallery img, .detail-media img'), function (el) {
      return !el.closest('.acc-head') && !el.classList.contains('cc-nav-logo') && !el.closest('.waitlist');
    });
    lbItems.forEach(function (el) {
      el.classList.add('zoomable');
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'button');
      el.setAttribute('aria-label', 'Bild groß anzeigen: ' + (el.getAttribute('alt') || el.textContent.trim()));
    });
    var lb = null, lbGroup = [], lbIndex = 0, lbReturn = null;
    function lbGroupOf(el) {
      var g = el.closest('.ph-gallery');
      if (!g) return [el];
      return lbItems.filter(function (x) { return g.contains(x); });
    }
    function lbRender() {
      var el = lbGroup[lbIndex], stage = lb.querySelector('.cc-lb-stage');
      stage.innerHTML = '';
      var caption = el.getAttribute('alt') || el.textContent.trim();
      if (el.tagName === 'IMG') {
        var img = document.createElement('img');
        img.src = el.getAttribute('data-full') || el.currentSrc || el.src;
        img.alt = el.alt || '';
        stage.appendChild(img);
      } else {
        var ph = document.createElement('div');
        ph.className = 'cc-lb-ph';
        ph.textContent = caption;
        stage.appendChild(ph);
      }
      lb.querySelector('.cc-lb-bar').innerHTML = (lbGroup.length > 1 ? '<b>' + (lbIndex + 1) + ' / ' + lbGroup.length + '</b> · ' : '') + caption.replace(/[<>&]/g, '');
      lb.classList.toggle('single', lbGroup.length < 2);
    }
    function lbStep(d) { if (lbGroup.length < 2) return; lbIndex = (lbIndex + d + lbGroup.length) % lbGroup.length; lbRender(); }
    function lbClose() {
      if (!lb) return;
      document.documentElement.style.overflow = '';
      lb.remove(); lb = null;
      document.removeEventListener('keydown', lbKeys);
      if (lbReturn) lbReturn.focus({ preventScroll: true });
    }
    function lbKeys(e) {
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowRight') lbStep(1);
      else if (e.key === 'ArrowLeft') lbStep(-1);
    }
    function lbOpen(el) {
      lbReturn = el; lbGroup = lbGroupOf(el); lbIndex = Math.max(0, lbGroup.indexOf(el));
      lb = document.createElement('div');
      lb.className = 'cc-lb';
      lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Bildansicht');
      lb.innerHTML =
        '<div class="cc-lb-stage"></div>' +
        '<button class="cc-lb-close" type="button" aria-label="Schließen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '<button class="cc-lb-prev" type="button" aria-label="Vorheriges Bild"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg></button>' +
        '<button class="cc-lb-next" type="button" aria-label="Nächstes Bild"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></button>' +
        '<div class="cc-lb-bar"></div>';
      document.body.appendChild(lb);
      document.documentElement.style.overflow = 'hidden';
      lbRender();
      requestAnimationFrame(function () { if (lb) lb.classList.add('is-open'); });
      lb.querySelector('.cc-lb-close').addEventListener('click', lbClose);
      lb.querySelector('.cc-lb-prev').addEventListener('click', function (e) { e.stopPropagation(); lbStep(-1); });
      lb.querySelector('.cc-lb-next').addEventListener('click', function (e) { e.stopPropagation(); lbStep(1); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('cc-lb-stage')) lbClose(); });
      var x0 = null;
      lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 50) lbStep(dx < 0 ? 1 : -1);
      });
      document.addEventListener('keydown', lbKeys);
      lb.querySelector('.cc-lb-close').focus({ preventScroll: true });
    }
    lbItems.forEach(function (el) {
      el.addEventListener('click', function (e) { e.stopPropagation(); lbOpen(el); });
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); lbOpen(el); } });
    });

    // ---------- Überblick-Karten: Klick führt zum passenden Abschnitt ----------
    root.querySelectorAll('.module-card.is-link[data-href]').forEach(function (card) {
      function go() {
        var h = card.getAttribute('data-href');
        if (openFromHash(h, true)) return;
        var t = root.querySelector(h);
        if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
      card.addEventListener('click', function (e) { if (e.target.closest('a')) return; go(); });
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
    });

    // ---------- Endlos-Clips: bei „reduzierte Bewegung“ anhalten ----------
    if (reduce) root.querySelectorAll('video[autoplay]').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); v.controls = true; });

    // ---------- Ausblick: klickbare Einträge mit Bild ----------
    root.querySelectorAll('[role="tablist"]').forEach(function (list) {
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowDown' || k === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (k === 'ArrowUp' || k === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });

    // ---------- Zwei-Klick-Video: YouTube wird erst nach Klick geladen (youtube-nocookie) ----------
    root.querySelectorAll('.video[data-yt]').forEach(function (box) {
      var btn = box.querySelector('.play');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var id = box.getAttribute('data-yt');
        if (!id || id === 'YOUTUBE-ID') { box.querySelector('b').textContent = 'Video folgt in Kürze.'; return; }
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
        f.title = 'CraftConsole Pro Video';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        box.innerHTML = '';
        box.appendChild(f);
      });
    });

    // ---------- Platzhalter-Formular: sendet nichts, bis das Warteliste-Tool angeschlossen ist ----------
    root.querySelectorAll('form[data-placeholder="true"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        form.querySelector('.form-msg').textContent = 'Die Warteliste wird gerade eingerichtet. Schau bald wieder vorbei!';
      });
    });

    // ---------- Nach dem Absenden (Shopify lädt die Seite neu): zur Warteliste springen, damit man die Meldung sieht ----------
    // Rücksprung nach dem Eintragen (return_to …?warteliste=danke): Shopify gibt dann keinen Formularstatus mit
    if (/[?&]warteliste=danke/.test(location.search)) {
      var msg = root.querySelector('.waitlist .form-msg');
      if (msg && !msg.textContent.trim()) msg.textContent = 'Fast geschafft: Bitte bestätige deine Anmeldung über den Link in der E-Mail, die du gleich bekommst.';
    }
    if (/[?&](customer_posted=true|warteliste=danke)/.test(location.search) || root.querySelector('.waitlist .form-msg:not(:empty)')) {
      var wl = root.querySelector('#warteliste');
      if (wl) setTimeout(function () { wl.scrollIntoView({ behavior: 'instant', block: 'center' }); }, 60);
    }
  })();
